import axios from '../internal/axios';
export var getCategories = function getCategories() {
  return axios.get("/categories?target=0").then(function (response) {
    return response.data;
  }).then(function (result) {
    if (result.success) {
      return result.data;
    } else {
      throw Error(result.message);
    }
  }).then(function (payload) {
    return {
      payload: payload
    };
  }).catch(function (error) {
    var message = error.message;
    return {
      error: message
    };
  });
};
export var getCategoryById = function getCategoryById(categoryId) {
  return axios.get("/categories/".concat(categoryId)).then(function (response) {
    return response.data;
  }).then(function (result) {
    if (result.success) {
      return result.data;
    } else {
      throw Error(result.message);
    }
  }).then(function (payload) {
    return {
      payload: payload
    };
  }).catch(function (error) {
    var message = error.message;
    return {
      error: message
    };
  });
};
export var getBulkPrice = function getBulkPrice() {
  return axios.get("/categories_bulk").then(function (response) {
    return response.data;
  }).then(function (result) {
    if (result.success) {
      return result;
    } else {
      throw Error(result.message);
    }
  }).then(function (payload) {
    return {
      payload: payload
    };
  }).catch(function (error) {
    var message = error.message;
    return {
      error: message
    };
  });
};